<template>
  <section>
    <h2 class="text-2xl font-bold mb-6">消费记录</h2>
    <div v-if="loading" class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm text-center text-textSub">
      加载中…
    </div>
    <div v-else class="bg-white rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <table class="w-full">
        <thead>
          <tr class="bg-gray-50 border-b border-gray-200">
            <th class="py-3 px-4 text-left text-textSub">名称</th>
            <th class="py-3 px-4 text-left text-textSub">日期</th>
            <th class="py-3 px-4 text-left text-textSub">类型</th>
            <th class="py-3 px-4 text-left text-textSub">剩余创作点</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in records" :key="index" class="border-b border-gray-200 hover:bg-gray-50">
            <td class="py-3 px-4">{{ row.detail || '-' }}</td>
            <td class="py-3 px-4 text-textSub">{{ row.createTime }}</td>
            <td class="py-3 px-4 text-textSub">{{ consumeTypeText(row.type) }}</td>
            <td class="py-3 px-4">{{ row.golaCoinBalance != null ? row.golaCoinBalance : '-' }}</td>
          </tr>
          <tr v-if="records.length === 0">
            <td colspan="4" class="py-6 px-4 text-center text-textSub text-sm">暂无消费记录</td>
          </tr>
        </tbody>
      </table>
      <div class="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50">
        <div class="text-sm text-textSub">
          第 {{ currentPage }} 页
        </div>
        <div class="space-x-2">
          <button
            class="px-3 py-1 rounded border text-sm btn-hover"
            :class="currentPage <= 1 ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
            :disabled="currentPage <= 1"
            @click="changePage(currentPage - 1)"
          >
            上一页
          </button>
          <button
            class="px-3 py-1 rounded border text-sm btn-hover"
            :class="!hasMore ? 'border-gray-200 text-gray-300 cursor-not-allowed' : 'border-gray-300 text-textMain'"
            :disabled="!hasMore"
            @click="changePage(currentPage + 1)"
          >
            下一页
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getConsumeHistory } from '../api/consume'

const TYPE_MAP = {
  '1': '创作点数消费',
  '2': '会员充值'
}

export default {
  name: 'ConsumeRecord',
  props: {
    active: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      records: [],
      currentPage: 1,
      pageSize: 10,
      hasMore: true
    }
  },
  mounted () {
    if (this.active) this.fetchRecords()
  },
  watch: {
    active (val) {
      if (val) this.fetchRecords()
    }
  },
  methods: {
    formatDateTime (str) {
      if (!str) return '-'
      // 只保留到日期部分，兼容 2026-02-26T12:55:15.000+00:00 或 2026-02-26 12:55:15
      var s = String(str)
      if (s.indexOf('T') !== -1) {
        return s.split('T')[0]
      }
      return s.split(' ')[0] || '-'
    },
    consumeTypeText (type) {
      if (type == null || type === '') return '-'
      var key = String(type)
      return TYPE_MAP[key] || key
    },
    async fetchRecords (page) {
      if (typeof page === 'number' && page > 0) {
        this.currentPage = page
      }
      const fromIndex = this.currentPage
      this.loading = true
      try {
        const res = await getConsumeHistory(fromIndex, this.pageSize)
        const list = res && Array.isArray(res.list) ? res.list : []
        const total = res && typeof res.total === 'number' ? res.total : list.length
        this.loading = false
        this.records = list
        this.hasMore = this.currentPage * this.pageSize < total
      } catch (err) {
        this.loading = false
        this.records = []
        this.hasMore = false
      }
    },
    changePage (page) {
      if (page < 1) return
      if (!this.hasMore && page > this.currentPage) return
      this.fetchRecords(page)
    }
  }
}
</script>
